import { render, staticRenderFns } from "./DataRecordSettingsFields.vue?vue&type=template&id=031d827f&scoped=true&"
import script from "./DataRecordSettingsFields.vue?vue&type=script&lang=ts&"
export * from "./DataRecordSettingsFields.vue?vue&type=script&lang=ts&"
import style0 from "./DataRecordSettingsFields.vue?vue&type=style&index=0&id=031d827f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "031d827f",
  null
  
)

export default component.exports